import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import $ from "jquery";
import { RouterProvider } from "react-router5";
import { configureRouter } from "./create-router";
//@ts-ignore
window.__forceSmoothScrollPolyfill__ = true;

// eslint-disable-next-line import/first
import smoothscroll from "smoothscroll-polyfill";

// kick off the polyfill!
smoothscroll.polyfill();
const RetardedJQuerryPolyfill = () => {
  $(document).ready(function () {
    $(".locallink").click(function () {
      focus("#" + $(this).attr("data-id"), 80);
    });
  });
  
  function focus(obj: any, shift: any) {
    if (shift === undefined) {
      shift = 35;
    }
    //@ts-ignore
    $("html, body").animate({ scrollTop: $(obj).offset().top - shift }, 700);
  }
}

// RetardedJQuerryPolyfill()

const test = "test1";

const router = configureRouter();

router.start(() => {
  ReactDOM.render(
    <React.StrictMode>
      <RouterProvider router={router}>
        <App />
      </RouterProvider>
    </React.StrictMode>,
    document.getElementById("root")
  );
});

//@ts-ignore
window.test = 2;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


